import Marquee from "react-fast-marquee";
import { Mark } from "@/components/Logo";

export const Ticker = ({ items, dark = true, speed = 40, className = "" }) => (
  <div
    data-testid="marquee-ticker"
    className={`border-y ${dark ? "border-coal bg-ink text-white" : "border-fog bg-paper text-ink"} py-3 ${className}`}
  >
    <Marquee speed={speed} gradient={false} autoFill pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-6 mx-6">
          <span className="font-mono-label">{item}</span>
          <Mark white={dark} alt="" className="h-3.5 w-4 opacity-60" />
        </span>
      ))}
    </Marquee>
  </div>
);
